module.exports = __webpack_public_path__ + "static/media/teeth.81112fde.png";